module.exports = __webpack_public_path__ + "static/NotoSans-Regular-5a87cce84010f7cea085ae218d44a64b.ttf";